import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { articles } from '@/mocks/articles';

const articleListImages: Record<string, string> = {
  'article-1': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20college%20student%20getting%20hair%20styled%20in%20elegant%20salon%2C%20warm%20rose%20and%20cream%20interior%2C%20soft%20natural%20lighting%2C%20minimalist%20design%2C%20editorial%20photography&width=600&height=400&seq=article-list-1&orientation=landscape',
  'article-2': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20student%20doing%20skincare%20routine%20with%20serum%2C%20bright%20clean%20bathroom%2C%20warm%20soft%20lighting%2C%20cream%20tones%2C%20minimalist%20aesthetic&width=600&height=400&seq=article-list-2&orientation=landscape',
  'article-3': 'https://readdy.ai/api/search-image?query=Beautiful%20young%20asian%20female%20with%20trendy%20wavy%20hairstyle%20on%20campus%2C%20autumn%20vibes%2C%20warm%20tones%2C%20editorial%20fashion%20photography&width=600&height=400&seq=article-list-3&orientation=landscape',
  'article-4': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20student%20applying%20makeup%20at%20vanity%20desk%2C%20fresh%20morning%20light%2C%20minimalist%20bedroom%2C%20warm%20cozy%20atmosphere%2C%20editorial%20style&width=600&height=400&seq=article-list-4&orientation=landscape',
  'article-5': 'https://readdy.ai/api/search-image?query=Elegant%20manicured%20female%20hands%20with%20beautiful%20nail%20art%20design%2C%20delicate%20jewelry%2C%20soft%20warm%20lighting%2C%20vintage%20aesthetic%2C%20editorial%20photography&width=600&height=400&seq=article-list-5&orientation=landscape',
  'article-6': 'https://readdy.ai/api/search-image?query=College%20graduate%20female%20student%20in%20cap%20and%20gown%20with%20flawless%20makeup%20smiling%2C%20university%20campus%2C%20sunny%20day%2C%20celebratory%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=article-list-6&orientation=landscape',
};

export default function ArticlesPage() {
  const breadcrumbItems = [
    { name: '首页', path: '/' },
    { name: '美丽资讯' },
  ];

  const articleListSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '美丽资讯 - 女大学生的沙龙室',
    description: '最懂女大学生的美妆护肤干货分享，涵盖发型趋势、化妆教程、护肤攻略、美甲入门等丰富内容。',
    url: 'https://readdy.ai/articles',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(articleListSchema)}</script>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16 md:pt-18">
        <Breadcrumb items={breadcrumbItems} />

        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8 md:mb-12">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                美丽资讯
              </h1>
              <p className="mt-2 text-sm text-foreground-600">
                最懂女大学生的美妆护肤干货分享
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/articles/${article.id}`}
                  className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-200 hover:bg-background-200/70"
                >
                  <div className="relative w-full h-48 md:h-56 overflow-hidden">
                    <img
                      src={articleListImages[article.id] || ''}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-3 mb-2 flex-wrap">
                      <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-500">
                        {article.readTime}
                      </span>
                      <span className="text-xs text-foreground-400">
                        {article.date}
                      </span>
                    </div>
                    <h2 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                      {article.title}
                    </h2>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                      {article.summary}
                    </p>
                    <div className="mt-3 flex items-center gap-2 flex-wrap">
                      {article.tags.map((tag) => (
                        <span
                          key={tag}
                          className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}